import CheckoutResultContainer from './CheckoutResultContainer.js';
export default CheckoutResultContainer;